/** Public-site copy and the app store listing URLs. */
export const site = {
  name: 'Dala',
  wordmark: 'dala',
  tagline: 'Rides · Food · Stores · Parcels',
  headline: 'All of MABAMA, in your pocket.',
  region: 'Magsaysay, Bansalan & Matanao (MABAMA)',
  country: 'Philippines',
  packageId: 'com.richtone.hatod',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.richtone.hatod',
  appStoreUrl: 'https://apps.apple.com/ph/app/dala-ride-food-delivery/id6805111181',
  facebookUrl: 'https://www.facebook.com/people/Dala/61594316644458/',
  supportEmail: 'support@dala.delivery',
  infoEmail: 'info@dala.delivery',
  partnersEmail: 'partners@dala.delivery',
  privacyEmail: 'privacy@dala.delivery',
  operator: 'Dala',
  lastUpdated: '16 September 2026',
  /**
   * The terms moved on after the rest of the site did, when the
   * community rules went in. Kept separate so republishing the terms
   * does not silently restamp the privacy policy as well — the in-app
   * copy (`kTermsVersion`) and the acceptance receipts on user accounts
   * are keyed to this exact string.
   */
  termsUpdated: '18 September 2026',
} as const;
